import React, { Suspense } from 'react';
import { ImmutableEntity, ParagraphEntity } from '@uncinc/react-drupal-core/types';

interface ParagraphPersonsFilteredProps {
  entity: ImmutableEntity<ParagraphEntity>;
}

const ParagraphPersonsFilteredLazy = React.lazy(() => import('./index.lazy'));

const ParagraphPersonsFiltered: React.FC<ParagraphPersonsFilteredProps> = (props) => (
  <Suspense fallback={<div />}>
    <ParagraphPersonsFilteredLazy {...props} />
  </Suspense>
);

export default ParagraphPersonsFiltered;
